module.exports = __webpack_public_path__ + "static/img/starMemberBg1.840aaa02.png";